
define('ldsh!modules/emblue/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="emblue">\n\n\n  ';
 if (status===false) { ;
__p += '\n    <div class="spinner__container"></div>\n    <h2 class="i18n" data-i18n="EMBLUE.WELCOME"></h2>\n    <p class="i18n" data-i18n="EMBLUE.CREATING"></p>\n    ';
 } ;
__p += '\n      ';
 if ( status==1) { ;
__p += '\n        <div class="error"></div>\n        <h2 class="i18n" data-i18n="EMBLUE.CREATED_ERROR_1"></h2>\n        <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_2"></p>\n        <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_EXIST_3"\n          data-i18n-options=\'{"email": "' +
__e( email ) +
'", "groupId": "' +
__e( groupId ) +
'", "phone": "' +
__e( phone ) +
'"}\'></p>\n        ';
 } ;
__p += '\n          ';
 if ( status==2) { ;
__p += '\n            <div class="account__created"></div>\n            <h2 class="i18n" data-i18n="EMBLUE.WELCOME_CREATED"></h2>\n            <p class="i18n" data-i18n="EMBLUE.CREATED_1"></p>\n            <p class="i18n" data-i18n="EMBLUE.CREATED_2"></p>\n            <p class="i18n" data-i18n="[html]EMBLUE.CREATED_3"></p>\n            ';
 } ;
__p += '\n\n              ';
 if ( status==3) { ;
__p += '\n                <div class="error"></div>\n                <h2 class="i18n" data-i18n="EMBLUE.CREATED_ERROR_1"></h2>\n                <p class="i18n" data-i18n="EMBLUE.CREATED_ERROR_EXIST_1"></p>\n                <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_EXIST_2"></p>\n                <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_EXIST_3"\n                  data-i18n-options=\'{"email": "' +
__e( email ) +
'", "groupId": "' +
__e( groupId ) +
'", "phone": "' +
__e( phone ) +
'"}\'>\n                </p>\n                ';
 } ;
__p += '\n\n\n</div>';

}
return __p
};});

